var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 41H18V41.5C18 42.3501 18.6499 43 19.5 43H37.5C38.3501 43 39 42.3501 39 41.5V15.5C39 14.6499 38.3501 14 37.5 14H36V15H37.5C37.8 15 38 15.2 38 15.5V41.5C38 41.8 37.8 42 37.5 42H19.5C19.2 42 19 41.8 19 41.5V41H35.5C36.3501 41 37 40.3501 37 39.5V17.3L32.7 13H17.5C16.6499 13 16 13.6499 16 14.5V39.5C16 40.3501 16.6499 41 17.5 41V41ZM33 14.7L35.3 17H33.5C33.2 17 33 16.8 33 16.5V14.7ZM17 14.5C17 14.2 17.2 14 17.5 14H32V16.5C32 17.3501 32.6499 18 33.5 18H36V39.5C36 39.8 35.8 40 35.5 40H17.5C17.2 40 17 39.8 17 39.5V14.5Z",
    fill: "#1A35C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 29H30.5V30H26.5V29Z",
    fill: "#1A35C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 29H25V30H18.5V29Z",
    fill: "#1A35C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31.5H30.5V32.5H26.5V31.5Z",
    fill: "#1A35C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 34H30.5V35H26.5V34Z",
    fill: "#1A35C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 31.5H25V32.5H18.5V31.5Z",
    fill: "#1A35C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 34H25V35H18.5V34Z",
    fill: "#1A35C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 36.5H25V37.5H18.5V36.5Z",
    fill: "#1A35C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 36.5H30.5V37.5H26.5V36.5Z",
    fill: "#1A35C2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29H34.5V30H32V29Z",
    fill: "#DC332E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31.5H34.5V32.5H32V31.5Z",
    fill: "#DC332E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34H34.5V35H32V34Z",
    fill: "#DC332E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36.5H34.5V37.5H32V36.5Z",
    fill: "#DC332E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1001 22.5H28.8501L29.8501 19H30.5V18H29.25L27.25 15.5H25.75L23.75 18H22.5V19H23.1001L24.1001 22.5ZM28.1001 21.5H24.8501L24.1499 19H28.8L28.1001 21.5ZM26.25 16.5H26.75L27.95 18H25.05L26.25 16.5Z",
    fill: "#DC332E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 26.5H34.5V27.5H18.5V26.5Z",
    fill: "#1A35C2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24H29.5V25H23.5V24Z",
    fill: "#1A35C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesorder);
export default __webpack_public_path__ + "static/media/Salesorder.b4d827ae3745431413942895cb88139f.svg";
export { ForwardRef as ReactComponent };